import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from 'app/app.service';
import { SessioneUtenteQuery } from 'app/main/utils/state';
import { TipoCorso } from 'app/main/utils/utils';
import {} from 'jquery';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, retry } from 'rxjs/operators';
import { Costanti } from '../../utils/costanti';
import { LoaderOptions, loaderContext } from '../../utils/loader.interceptor';
import {
  AnsweredQuestion,
  AnsweredSatisfactionQuestion,
  AnsweredTestQuestion,
  CourseEnrollmentResponse,
  CourseEventsResponse,
  CourseIndexResponse,
  CourseIntroductionResponse,
  CourseMeetingEntryResponse,
  CourseMeetingVODSubmitResponse,
  CourseMeetingVODTokenResponse,
  CourseRatingResponse,
  CourseRatingSubmitResponse,
  CourseRecruitingResponse,
  CourseStatusResponse,
  CoursesResponse,
  CreditsResponse,
  ExplainedAnswer,
  InvoiceDataResponse,
  InvoiceModDataResponse,
  InvoicesResponse,
  LibraryResponse,
  MyCourse,
  MyCoursesResponse,
  MyCoursesYearsResponse,
  NewSatisfactionResponse,
  NewTestResponse,
  PaymentRealizedResponse,
  PublishedCoursesResponse,
  SatisfactionSubmitResponse,
  ScientificCommitteeResponse,
  SetTokenResponse,
  TestAccessibilityResponse,
  TestAttemptResponse,
  TestSubmitResponse,
  TotalCoursesResponse,
  UnitResponse,
  UnitaSubmitResponse,
  VoucherCheckResponse
} from './corso/interface-corsi';
const BASEURL = Costanti.APIURL + 'corsi/';
// const BASEURLCORSI = 'https://corsi.andi.it/api/corsi/';
const BASEURLCORSI = Costanti.urlApiCorsi;
const BASEURL8108 = Costanti.urlApi8108;
interface VerificaDatiAnagraficiSuccess {
  verifica_dati_anagrafici: {
    esito: boolean;
  };
}
interface VerificaDatiAnagraficiError {
  public_error: string[];
}
@Injectable({
  providedIn: 'root'
})
export class CorsiService {
  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  rinnovaContenuto(
    tipo: 'unita' | 'introduzione' | 'biblioteca',
    corsoPartecipanteId: string,
    corsoId: string,
    codiceDiAccessoTutor?: string,
    unitaId?: number,
    libreriaId?: number
  ): Observable<any> {
    const body = corsoPartecipanteId
      ? { brainId: this.getId(), corsoPartecipanteId, unitaId, libreriaId }
      : { brainId: this.getId(), corsoId, codiceDiAccessoTutor, unitaId, libreriaId };
    const route = (corsoPartecipanteId ? '' : 'tutor_') + tipo;
    return this.http
      .post(BASEURLCORSI + route, body, { ...loaderContext({ noGlobalLoader: true }), withCredentials: true })
      .pipe(
        map(this.extractData),
        map(data => {
          if (data.error_desc || !data[tipo]) {
            throw { status: 403, message: 'Contenuto non più accessibile' };
          }
          return data[tipo];
        })
      );
  }

  constructor(
    private http: HttpClient,
    private sessioneUtenteQuery: SessioneUtenteQuery,
    private appService: AppService
  ) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }
  private extractDataDatiFiscali(res) {
    return res['data'] || { ...res };
  }

  private handleCorsiError(error: any): Observable<never> {
    console.error(`CORSI ERROR: ${error}`);
    console.warn(`CONTROLLARE NETWORK > RICHIESTA IN ERRORE > PREVIEW PER MAGGIORI INFORMAZIONI`);
    return throwError(() => error);
  }

  private getId() {
    // return 4513; // Corso ipnosi (per unità con video)
    // return 4618; // Tanti corsi
    // return 17317;
    return this.sessioneUtenteQuery.loggedUser().id;
  }

  isQuotaFinanziabilePagoLight(quota: number) {
    return quota > 60 && quota < 5000;
  }

  listaProvince(): Observable<{ province: string[] }> {
    const url = BASEURLCORSI + 'lista_province';

    this.loadingSubject.next(true);
    return this.http.post(url, {}).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  setToken(): Observable<SetTokenResponse> {
    const url = BASEURL + 'set_token';
    const body = {};

    return this.http.post(url, body).pipe(map(this.extractData), catchError(this.handleCorsiError));
  }

  getComitatoScientifico(): Observable<ScientificCommitteeResponse> {
    const url = BASEURLCORSI + 'comitato_scientifico';
    const body = {};

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  stampaCVComitatoScientifico(responsabileScientificoId: number) {
    const url = BASEURLCORSI + 'stampa_cv_responsabile_scientifico';
    const body = { responsabileScientificoId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  getLista(
    tipoCorso: TipoCorso,
    tipoCorsoFad?: 'Asincrono' | 'Sincrono',
    options?: LoaderOptions
  ): Observable<PublishedCoursesResponse> {
    const url = BASEURLCORSI + 'pubblicati';
    const body = { brainId: this.getId(), tipoCorso, tipoCorsoFad };

    const useLoader = !options?.noGlobalLoader;
    if (useLoader) this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => {
        if (useLoader) this.loadingSubject.next(false);
      })
    );
  }

  verificaIMieiDatiAnagrafici(): Observable<any> {
    // VerificaDatiAnagraficiSuccess | VerificaDatiAnagraficiError
    const url = BASEURLCORSI + 'verifica_i_miei_dati_anagrafici';
    const body = { brainId: this.getId() };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  verificaIMieiDatiFatturazione(): Observable<any> {
    // VerificaDatiAnagraficiSuccess | VerificaDatiAnagraficiError
    const url = BASEURLCORSI + 'verifica_i_miei_dati_di_fatturazione';
    const body = { brainId: this.getId() };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  verificaDatiFatturazione(dati: {
    ragione_sociale_studio: string;
    partita_iva_studio: string;
    codice_sdi_studio: string;
    pec_studio: string;
    indirizzo_studio: string;
    cap_studio: string;
    citta_indirizzo_studio: string;
    provincia_studio: string; //nome
  }): Observable<any> {
    // VerificaDatiAnagraficiSuccess | VerificaDatiAnagraficiError
    const url = BASEURLCORSI + 'verifica_dati_di_fatturazione';
    const body = { brainId: this.getId(), ...dati };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getDatiFatturazione(options?: LoaderOptions): Observable<InvoiceDataResponse> {
    const url = BASEURLCORSI + 'i_miei_dati_di_fatturazione';
    const body = { brainId: this.getId() };

    this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  modificaDatiFiscali(payload: {
    codice_fiscale: string;
    partita_iva: string;
    codice_destinatario: string;
    pec: string;
    via: string;
    cap: string;
    citta: string;
    provincia: string;
  }): Observable<any> {
    const url = BASEURLCORSI + 'modifica_dati_fiscali';
    const body = { brainId: this.getId(), ...payload };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractDataDatiFiscali),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  modificaDatiFatturazione(payload: {
    dati_fatturazione_diversi: boolean;
    ragione_sociale_studio: string;
    partita_iva_studio: string;
    codice_sdi_studio: string;
    pec_studio: string;
    indirizzo_studio: string;
    cap_studio: string;
    citta_indirizzo_studio: string;
    provincia_studio: string;
  }): Observable<InvoiceModDataResponse | { public_error?: string[] }> {
    const url = BASEURLCORSI + 'modifica_dati_di_fatturazione';
    const body = { brainId: this.getId(), ...payload };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCreditiEcm(anno: string): Observable<CreditsResponse> {
    const url = BASEURLCORSI + 'i_miei_crediti_ecm';
    const body = { brainId: this.getId(), anno };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getTotaleMieiCorsi(anno?: string): Observable<TotalCoursesResponse> {
    const url = BASEURLCORSI + 'tot_miei_corsi_completati';
    const body = { brainId: this.getId() };

    if (anno) body['anno'] = anno;

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getMieiCorsiAnni(): Observable<MyCoursesYearsResponse> {
    const url = BASEURLCORSI + 'i_miei_anni_corsi';
    const body = { brainId: this.getId() };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getMieiCorsi(anno?: string, tipoCorso?: TipoCorso): Observable<MyCoursesResponse> {
    const url = BASEURLCORSI + 'i_miei_corsi';
    const body = { brainId: this.getId() };

    if (anno) body['anno'] = anno;
    if (tipoCorso) body['tipoCorso'] = tipoCorso;

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  arricchisciConAnteprime(corsi: MyCourse[]): Observable<MyCourse[]> {
    return of(
      corsi.map(c => ({
        ...c,
        anteprimaUrl: Costanti.urlCopertina(c['immagineCopertina']),
        trailerUrl: c['videoTrailer'] || undefined
      }))
    );
  }

  getDettaglioCorso(
    corsoId: string,
    corsoPartecipanteId?: string,
    options?: LoaderOptions
  ): Observable<CoursesResponse> {
    const url = BASEURLCORSI + 'dettaglio';
    const body = { brainId: this.getId(), corsoId, corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoIntro(corsoPartecipanteId: string): Observable<CourseIntroductionResponse> {
    const url = BASEURLCORSI + 'introduzione';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoClassi(corsoId: string, options?: LoaderOptions): Observable<CourseEventsResponse> {
    const url = BASEURLCORSI + 'classi';
    const body = { brainId: this.getId(), corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  parseHtmlForAws(htmlString: string): Observable<JSON> {
    const url = BASEURL + 'parse-body';
    const body = { htmlString };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  dichiarazioneReclutamento(
    corsoPartecipanteId: string,
    reclutato: boolean,
    aziendaReclutante: string
  ): Observable<CourseRecruitingResponse> {
    const url = BASEURLCORSI + 'dichiarazione_reclutamento';
    const body = { brainId: this.getId(), corsoPartecipanteId, reclutato, aziendaReclutante };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoIndice(corsoPartecipanteId: string): Observable<CourseIndexResponse> {
    const url = BASEURLCORSI + 'indice';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoMeetingAccesso(corsoPartecipanteId: string, meetingId: number): Observable<CourseMeetingEntryResponse> {
    const url = BASEURLCORSI + 'meeting_accesso';
    const body = { brainId: this.getId(), corsoPartecipanteId, meetingId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoValutazione(corsoPartecipanteId: string): Observable<CourseRatingResponse> {
    const url = BASEURLCORSI + 'valutazione_corso';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getTestTentativo(corsoPartecipanteId: string, testTentativoId: number): Observable<TestAttemptResponse> {
    const url = BASEURLCORSI + 'test_tentativo';
    const body = { brainId: this.getId(), corsoPartecipanteId, testTentativoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getTest(corsoPartecipanteId: string, testId: number): Observable<NewTestResponse> {
    const url = BASEURLCORSI + 'test';
    const body = { brainId: this.getId(), corsoPartecipanteId, testId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getQuestionario(
    corsoPartecipanteId: string,
    valutazioneSoddisfazioneId: number
  ): Observable<NewSatisfactionResponse> {
    const url = BASEURLCORSI + 'valutazione_soddisfazione';
    const body = { brainId: this.getId(), corsoPartecipanteId, valutazioneSoddisfazioneId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getUnita(corsoPartecipanteId: string, unitaId: number): Observable<UnitResponse> {
    const url = BASEURLCORSI + 'unita';
    const body = { brainId: this.getId(), corsoPartecipanteId, unitaId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getBiblioteca(corsoPartecipanteId: string): Observable<LibraryResponse> {
    const url = BASEURLCORSI + 'biblioteca';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoStatus(corsoPartecipanteId: string): Observable<CourseStatusResponse> {
    const url = BASEURLCORSI + 'status';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getStatusAccessibilita(corsoPartecipanteId: string): Observable<TestAccessibilityResponse> {
    const url = BASEURLCORSI + 'status_accessibilita_test_finali';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getFatture(): Observable<InvoicesResponse> {
    const url = BASEURLCORSI + 'fatture';
    const body = { brainId: this.getId() };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getEventi(corsoId) {
    const url = BASEURL8108 + 'eventi';
    const body = { brainId: this.getId(), corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  postCorsoIscrizione(corsoId: string, bodyReq: Object, options?: LoaderOptions): Observable<CourseEnrollmentResponse> {
    const url = BASEURLCORSI + 'iscrizione';
    const body = { brainId: this.getId(), corsoId, ...bodyReq };

    this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  postUnitaSubmit(
    corsoPartecipanteId: string,
    unitaId: number,
    dataInizio: string,
    dataFine: string
  ): Observable<UnitaSubmitResponse> {
    const url = BASEURLCORSI + 'unita_submit';
    const body = { brainId: this.getId(), corsoPartecipanteId, unitaId, dataInizio, dataFine };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getRegistrazioneToken(corsoPartecipanteId, meetingId: number): Observable<CourseMeetingVODTokenResponse> {
    const url = BASEURLCORSI + 'registrazione_meeting_set_token';
    const body = { brainId: this.getId(), corsoPartecipanteId, meetingId: meetingId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  submitVisualizzazioneRegistrazione(
    corsoPartecipanteId,
    meetingId: number,
    incontroId: number
  ): Observable<CourseMeetingVODSubmitResponse> {
    const url = BASEURLCORSI + 'registrazione_meeting_submit';
    const body = {
      brainId: this.getId(),
      corsoPartecipanteId,
      meetingId: meetingId,
      incontroId: incontroId
    };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  verificaVoucher(corsoId: number, codiceVoucher: string, options?: LoaderOptions): Observable<VoucherCheckResponse> {
    const url = BASEURLCORSI + 'verifica_voucher';
    const body = { brainId: this.getId(), corsoId, codiceVoucher };

    // this.loadingSubject.next(true);
    return this.http.post(url, body, loaderContext(options)).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError)
      // finalize(() => this.loadingSubject.next(false))
    );
  }

  postCorsoValutazione(
    corsoPartecipanteId: string,
    dataInizio: string,
    dataFine: string,
    domande: Array<AnsweredQuestion>,
    spiegazioni: Array<ExplainedAnswer>
  ): Observable<CourseRatingSubmitResponse> {
    const url = BASEURLCORSI + 'valutazione_corso_submit';
    const body = { brainId: this.getId(), corsoPartecipanteId, dataInizio, dataFine, domande, spiegazioni };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  postTest(
    corsoPartecipanteId: string,
    testId: number,
    dataInizio: string,
    dataFine: string,
    domande: Array<AnsweredTestQuestion>
  ): Observable<TestSubmitResponse> {
    const url = BASEURLCORSI + 'test_submit';
    const body = { brainId: this.getId(), corsoPartecipanteId, testId, dataInizio, dataFine, domande };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  postQuestionario(
    corsoPartecipanteId: string,
    valutazioneSoddisfazioneId: number,
    dataInizio: string,
    dataFine: string,
    anonimato: boolean,
    domande: Array<AnsweredSatisfactionQuestion>
  ): Observable<SatisfactionSubmitResponse> {
    const url = BASEURLCORSI + 'valutazione_soddisfazione_submit';
    const body = {
      brainId: this.getId(),
      corsoPartecipanteId,
      valutazioneSoddisfazioneId,
      dataInizio,
      dataFine,
      anonimato,
      domande
    };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  postDichiarazionePagamento(corsoPartecipanteId: string): Observable<PaymentRealizedResponse> {
    const url = BASEURLCORSI + 'dichiarazione_pagamento_effettuato';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  inviaRichiestaRimborso(
    corsoPartecipanteId: string,
    motivoRichiestaRimborso: string,
    intestatario: string,
    banca: string,
    iban: string
  ) {
    const url = BASEURLCORSI + 'stampa_modulo_rimborso';
    const body = { brainId: this.getId(), corsoPartecipanteId, motivoRichiestaRimborso, intestatario, banca, iban };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  stampaTestApprendimento(corsoPartecipanteId: string, testId: number) {
    const url = BASEURLCORSI + 'stampa_test_apprendimento';
    const body = { brainId: this.getId(), corsoPartecipanteId, testId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  stampaFattura(fatturaId: number) {
    const url = BASEURLCORSI + 'stampa_fattura';
    const body = { brainId: this.getId(), fatturaId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  stampaAttestato(attestatoId: number) {
    const url = BASEURLCORSI + 'stampa_attestato';
    const body = { brainId: this.getId(), attestatoId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  stampaValutazione(corsoPartecipanteId: number) {
    const url = BASEURLCORSI + 'stampa_valutazione_corso';
    const body = { brainId: this.getId(), corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  stampaBrochure(corsoId: number) {
    const url = BASEURLCORSI + 'stampa_brochure';
    const body = { brainId: this.getId(), corsoId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  getFile(nome_file: string) {
    const url = BASEURL + 'get-url-file';
    this.loadingSubject.next(true);
    const body = { nome_file };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  // ############################################################################# //

  getDettaglioFad(id_corso: string | number): Observable<JSON> {
    const url = BASEURL + 'dettaglio-corso-fad';
    const body = { id_corso };
    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getDettaglioFadWS(id: string): Observable<JSON> {
    const url = BASEURLCORSI + 'dettaglio';
    const body = { corsoId: id };
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON[]>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  // METODI VECCHI DA RIPULIRE

  getCategorie(): Observable<JSON[]> {
    const url = BASEURL + 'lista-categorie-corsi';

    this.loadingSubject.next(true);
    const body = {};

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON[]>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  // getLista(tipoCorso: TipoCorso): Observable<JSON> {
  //   let search = Utils.getTipoCorso(tipoCorso);

  //   const url = BASEURL + 'lista';
  //   this.loadingSubject.next(true);
  //   const body = {
  //     tipo_corso_id: search
  //   };

  //   return this.http.post(url, body).pipe(
  //     map(this.extractData),
  //     catchError(this.handleError<JSON[]>(url)),
  //     finalize(() => this.loadingSubject.next(false))
  //   );
  // }

  getCorso(id_corso): Observable<JSON> {
    const url = BASEURL + 'corso';

    this.loadingSubject.next(true);
    const body = { id_corso };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON[]>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  aggiungiCorsoSocio(id_corso): Observable<JSON> {
    const url = BASEURL + 'aggiungi-corso-socio';

    this.loadingSubject.next(true);
    const body = { id_corso };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON[]>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  // ###################################### //

  cercaCorsoTutor(key, id, code?: string) {
    const url = BASEURLCORSI + 'tutor_trova_corso';
    const body = { brainId: this.getId(), [key]: id, codiceDiAccessoTutor: code };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoIntroTutor(codiceDiAccessoTutor: string, corsoId: string) {
    const url = BASEURLCORSI + 'tutor_introduzione';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoIndiceTutor(codiceDiAccessoTutor: string, corsoId: string) {
    const url = BASEURLCORSI + 'tutor_indice';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getBibliotecaTutor(codiceDiAccessoTutor: string, corsoId: string) {
    const url = BASEURLCORSI + 'tutor_biblioteca';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getTestTutor(codiceDiAccessoTutor: string, corsoId: string, testId: number) {
    const url = BASEURLCORSI + 'tutor_test';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId, testId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getQuestionarioTutor(codiceDiAccessoTutor: string, corsoId: string, valutazioneSoddisfazioneId: number) {
    const url = BASEURLCORSI + 'tutor_valutazione_soddisfazione';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId, valutazioneSoddisfazioneId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getCorsoValutazioneTutor(codiceDiAccessoTutor: string, corsoId: string): Observable<CourseRatingResponse> {
    const url = BASEURLCORSI + 'tutor_valutazione_corso';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getUnitaTutor(codiceDiAccessoTutor: string, corsoId: string, unitaId: number): Observable<UnitResponse> {
    const url = BASEURLCORSI + 'tutor_unita';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, corsoId, unitaId };

    this.loadingSubject.next(true);
    return this.http.post(url, body, { withCredentials: true }).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  stampaTestApprendimentoTutor(codiceDiAccessoTutor: string, testId: number) {
    const url = BASEURLCORSI + 'tutor_stampa_test_apprendimento';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, testId };

    this.loadingSubject.next(true);
    return this.http
      .post(url, body, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        //retry(3),
        // map(this.extractData),
        catchError(this.handleCorsiError),
        finalize(() => this.loadingSubject.next(false))
      );
  }

  getCorsoMeetingAccessoTutor(codiceDiAccessoTutor: string, meetingId: number, corsoId: string) {
    const url = BASEURLCORSI + 'tutor_meeting_accesso';
    const body = { brainId: this.getId(), codiceDiAccessoTutor, meetingId, corsoId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getConversazione(corsoPartecipanteId): Observable<JSON> {
    const url = BASEURL + 'get-conversazione';
    const body = { corsoPartecipanteId };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  submitConversazione(corsoPartecipanteId, messaggio): Observable<JSON> {
    const url = BASEURL + 'submit-conversazione';
    const body = { corsoPartecipanteId, messaggio };

    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleCorsiError),
      finalize(() => this.loadingSubject.next(false))
    );
  }
}
